import Logo from "../img/pluri.png";

function SignUpLogo() {
  return (
    <div className="">
      <img
        src={Logo}
        alt="logo"
        style={{
          width: "100px",
          marginBottom: "10px",
          marginTop: "5px",
        }}
      />
    </div>
  );
}

export default SignUpLogo;
